import { render } from "./ModalPertenenciaDetalle.vue?vue&type=template&id=362f5076&scoped=true"
import script from "./ModalPertenenciaDetalle.vue?vue&type=script&lang=js"
export * from "./ModalPertenenciaDetalle.vue?vue&type=script&lang=js"

import "./ModalPertenenciaDetalle.vue?vue&type=style&index=0&id=362f5076&scoped=true&lang=css"

import exportComponent from "/home/usuario/Proyectos/2025/ArkhamHorror/App_Arkham_Horror_3/multigames/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-362f5076"]])

export default __exports__